import JourneyCard from "./card/journeyCard";
import "./journey.css";
import GASOLINEIMG from "../../../assets/images/New1000EFIPetrol/1000EFI_new_doors_1_HD-removebg-preview.png";
import TU01 from "../../../assets/images/1500EFIImg/1500E-2__1500E-3__Title_photo-removebg-preview.png";
import TUSC01 from "../../../assets/png/TUSC01.png";
import { RouterPaths } from "../../../router/router";
import Dualcab18 from "../../../assets/images/Dualcab18.jpg";

const Journey = ({ title }) => {
  const JourneyList = [
    {
      title: "GASOLINE",
      subTitle: "1000EFI MODEL",
      img: GASOLINEIMG,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.EFI,
      buttonText: "EXPLORE 1000EFI UTV",
    },
    {
      title: "ELECTRIC",
      subTitle: "1500E MODELS",
      img: TU01,
      Capacity: "2WD / 4WD",
      Models: 3,
      link: RouterPaths.TU1500E2,
      buttonText: "EXPLORE 1500E UTV",
    },
    {
      title: "ELECTRIC DUAL MOTOR",
      subTitle: "DC2500E MODELS",
      img: Dualcab18,
      Capacity: "2WD / 4WD",
      Models: 2,
      link: RouterPaths.TUDC2500E1,
      buttonText: "EXPLORE DC2500E UTV",
    },
  ];
  return (
    <>
      <h2 className="font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-center">
        {title}
      </h2>{" "}
      <div className=" 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal text-center">
        Narrow down our lineup of models and compare up to 3 vehicles at a time.
      </div>
      <div className="flex items-center justify-center mb-[90px] mt-[35px]">
        <div className="bg-[#7ABF5B] sm:h-[5px] h-[4px] sm:w-[350px] w-[150px]"></div>
      </div>
      <div class="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
        {JourneyList?.map((item) => {
          return <JourneyCard item={item} />;
        })}
      </div>
    </>
  );
};
export default Journey;
